import React, { createContext, useContext, useState } from 'react';
import { LocalStorageKeys } from 'Utils/localStorage';
import { TAGS_DISPLAY_OPTIONS } from '../../../appModules/Monitoring/subPanels/tags/constants';
// --- display options persist
const setStoredDisplayOptions = (options) => {
    const storedOptions = Object.keys(options).reduce((acc, key) => ({
        ...acc,
        [key]: { isChecked: options[key].isChecked, isDisabled: options[key].isDisabled }
    }), {});
    localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_CARDS_DISPLAY_OPTIONS, JSON.stringify(storedOptions));
};
const getStoredDisplayOptions = () => JSON.parse(localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_CARDS_DISPLAY_OPTIONS));
const getInitialDisplayOptions = () => {
    const storedOptions = getStoredDisplayOptions();
    if (storedOptions) {
        const mergedOptions = Object.keys(TAGS_DISPLAY_OPTIONS).reduce((acc, key) => {
            const storedOption = storedOptions[key];
            const optionDefinition = TAGS_DISPLAY_OPTIONS[key];
            if (storedOption) {
                return { ...acc, [key]: { ...optionDefinition, ...storedOption } };
            }
            return { ...acc, [key]: optionDefinition };
        }, {});
        return mergedOptions;
    }
    return TAGS_DISPLAY_OPTIONS;
};
// Context
const TagsCardsDisplayOptionsContext = createContext(null);
// Provider Component
const CardsDisplayOptionsProvider = ({ children }) => {
    const [currentDisplayOptions, setCurrentDisplayOptions] = useState(getInitialDisplayOptions());
    // Handlers
    const setDisplayOptions = (key) => {
        const { isChecked, linkedOptionKey } = currentDisplayOptions[key];
        let nextOptions = {
            ...currentDisplayOptions,
            [key]: {
                ...currentDisplayOptions[key],
                isChecked: !isChecked
            }
        };
        if (linkedOptionKey) {
            nextOptions = {
                ...nextOptions,
                [linkedOptionKey]: {
                    ...nextOptions[linkedOptionKey],
                    isChecked: !isChecked,
                    isDisabled: !!isChecked
                }
            };
        }
        setStoredDisplayOptions(nextOptions);
        setCurrentDisplayOptions(nextOptions);
    };
    // Render
    return (React.createElement(TagsCardsDisplayOptionsContext.Provider, { value: { displayOptions: currentDisplayOptions, setDisplayOptions } }, children));
};
// Custom Hook
export const useCardsDisplayOptions = () => useContext(TagsCardsDisplayOptionsContext);
export default CardsDisplayOptionsProvider;
